import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { loadCommunityProductCategory, loadCommunityProductCategorySuccess, loadCommunityProductCategoryFailure } from './community-product-category.action';
import { ApiResponse } from '../../models/common.model';
import { CustomerService } from '../../services/customer.service';

@Injectable()
export class CommunityProductCategoryEffects {
  constructor(private actions$: Actions, private http: HttpClient, private customerService: CustomerService) { }

  loadCommunityProductCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCommunityProductCategory),
      switchMap((action) => {
        return this.customerService.getAllCommunityProductCategoryList()
          .pipe(
            map((response: ApiResponse) => loadCommunityProductCategorySuccess({ communityProductCategory: response.body })),
            catchError((error) => of(loadCommunityProductCategoryFailure({ error })))
          );
      })
    )
  );
}